var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "icon flat-color",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#000000",
        width: "800px",
        height: "800px",
        viewBox: "0 0 24 24",
        id: "wallet-money",
        "data-name": "Flat Color",
      },
    },
    [
      _c("path", {
        staticStyle: { fill: "#ffa800" },
        attrs: {
          id: "secondary",
          d: "M10.91,4.06,6.74,10H5.58a1,1,0,0,1-.88-.54,1,1,0,0,1,.06-1l3.51-5A1,1,0,0,1,8.91,3a1,1,0,0,1,.75.16Zm8.66,1.56L14.66,2.18a1,1,0,0,0-1.39.25l-1.55,2.2L8,10h9.25A1,1,0,0,0,18,9.57L19.82,7a1,1,0,0,0-.25-1.39Z",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        staticStyle: { fill: "#3f3d56" },
        attrs: {
          id: "primary",
          x: "2",
          y: "8",
          width: "20",
          height: "14",
          rx: "2",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#ffa800" },
        attrs: {
          id: "secondary-2",
          "data-name": "secondary",
          d: "M17,13h5a0,0,0,0,1,0,0v4a0,0,0,0,1,0,0H17a1,1,0,0,1-1-1V14A1,1,0,0,1,17,13Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }